module.exports = __webpack_public_path__ + "img/mail_sent.d5e4f040.svg";